<!-- 角色编辑弹窗 -->
<template>
  <el-dialog :title="isUpdate ? '修改角色' : '添加角色'" :visible="visible" width="460px" :destroy-on-close="true"
    :lock-scroll="false" @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="82px">
      <el-form-item label="角色名称:" prop="name">
        <el-input :maxlength="20" v-model.trim="form.name" placeholder="请输入" clearable />
      </el-form-item>
      <el-form-item label="角色标识:" prop="code">
        <el-input :maxlength="20" v-model.trim="form.code" placeholder="请输入" clearable />
      </el-form-item>
      <el-form-item label="角色状态:">
        <el-radio-group v-model.trim="form.status">
          <el-radio v-for="item in statusOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序号:" prop="sort">
        <el-input-number :min="0" v-model.trim="form.sort" placeholder="请输入" controls-position="right"
          class="ele-fluid ele-text-left" />
      </el-form-item>
      <el-form-item label="备注:">
        <el-input :maxlength="200" v-model.trim="form.note" placeholder="请输入" :rows="4" type="textarea" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" @click="save" :loading="loading">确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { loadDictOptions } from '@/utils/dict';

export default {
  name: 'RoleEdit',
  props: {
    // 弹窗是否打开
    visible: Boolean,
    // 修改回显的数据
    data: Object
  },
  data() {
    return {
      // 表单数据
      form: Object.assign({}, this.data),
      // 表单验证规则
      rules: {
        name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入', trigger: 'blur' }
        ]
      },
      // 提交状态
      loading: false,
      // 是否是修改
      isUpdate: false,
      statusOptions: []
    };
  },
  mounted() {
    loadDictOptions('common_status', { numberValue: true })
      .then((list) => { this.statusOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
  },
  watch: {
    data() {
      if (this.data) {
        this.form = Object.assign({}, this.data);
        this.isUpdate = true;
      } else {
        this.form = { status: 1 };
        this.isUpdate = false;
      }
    }
  },
  methods: {
    /* 保存编辑 */
    save() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http.post('/role/edit', this.form).then(res => {
            this.loading = false;
            if (res.data.code === 0) {
              this.$message.success(res.data.msg);
              if (!this.isUpdate) {
                this.form = {};
              }
              this.updateVisible(false);
              this.$emit('done');
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
          });
        } else {
          return false;
        }
      });
    },
    /* 更新visible */
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped></style>
